import React from "react";

const ComingSoon = () => {
  return (
    <div className="container text-center mt-5">
      <h2 className="display-4 fw-bold  text-success ">Coming Soon</h2>
      <p className="lead">Stay tuned for exciting updates!</p>
      {/* <img src="https://via.placeholder.com/300" alt="Coming Soon" className="img-fluid mt-4" /> */}
    </div>
  );
}

export default ComingSoon;
